import UiService from "../../core/helpers/ui-service.helper";
import { CheckoutViewModel } from "./checkout.vm";

export const CheckoutInitialiser = () => {
  ko.applyBindings(new CheckoutViewModel(), document.body);
  $(() => {
    UiService.ApplyContainerMinHeight();
    UiService.ApplyCartPosition('#my-cart', '#checkout-container');
  });

  $(window).on('scroll',  () => {
    UiService.ApplyCartPosition('#my-cart', '#checkout-container');
  });
  $(window).on('resize', () => {
    UiService.ApplyCartPosition('#my-cart', '#checkout-container');
  });
}
 